import React from "react";

const ProgressStep = ({ activeStep }) => {
  const option = [
    {
      id: 1,
      stepNo: 1,
      details: "My Details",
    },
    {
      id: 2,
      stepNo: 2,
      details: "Patient Details",
    },
    {
      id: 3,
      stepNo: 3,
      details: "Opening Hours",
    },
    {
      id: 4,
      stepNo: 4,
      details: "Add Services",
    },
    {
      id: 5,
      stepNo: 5,
      details: "Add Doctors",
    },
    {
      id: 6,
      stepNo: 6,
      details: "Payment Setup",
    },
  ];

  return (
    <>
      <div className="col-md-12">
        <ul className="progresssteapes">
        {
  option.map((item, i) => (
    <li
      className={
        item.stepNo === activeStep
          ? "active showActive"
          : item.stepNo === activeStep + 1
          ? "showActive"
          : item.stepNo <= activeStep 
          ? "active"
          : ""
      }
      key={i}
    >
      <span>{item.stepNo}</span> <h6>{item.details}</h6>
    </li>
  ))
}

    </ul >
      </div >
    </>
  );
};

export { ProgressStep };
